module.exports = __webpack_public_path__ + "static/rebe-img-fddf578486f04284bbb57d2c0467e02c.jpg";